<template>
  <v-card>
    <v-card-title>Required Dates/Times</v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="required_dates"
        class="elevation-1"
        :loading="loading_table"
        hide-default-footer
      >
        <template v-slot:item.date="{ item }"><span>{{ item.date | formatDate }}</span></template>
        <template v-slot:item.start_time="{ item }"><span>{{ item.start_time | formatTime }}</span></template>
        <template v-slot:item.end_time="{ item }"><span>{{ item.end_time | formatTime }}</span></template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  data() {
    return {
      required_dates: [],
      headers: [
        { text: 'Date', value: 'date' },
        { text: 'Start Time', value: 'start_time' },
        { text: 'End Time', value: 'end_time' }
      ],
      loading_table: true
    }
  },
  filters: {
    formatDate: function(date) {
      return moment.utc(date).format('MM/DD/YYYY')
    },
    formatTime: function(time) {
      return moment.utc(time).format('h:mm a')
    }
  },
  mounted() {
    const vm = this
    const id = vm.$store.state.assignment
    const getOpusApi = firebase.functions().httpsCallable('getOpusApi')

    getOpusApi({
      table: `vendor_assignments/${id}`,
      params: {
        include: 'performance_slots'
      }
    }).then(function(response) {
      var slots = response.data.result.performance_slots
      // groups slots by day
      var groupedSlots = slots.reduce(function (acc, obj) {
        var key = obj['date']
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})

      var slotsArray = []
      for(var x in groupedSlots) { slotsArray.push({ [x]: groupedSlots[x] }) }
      slotsArray.forEach(function(arr, index) {
        var day = Object.keys(arr)[0]
        var daySlots = arr[day]

        // first day starts 2 hours before first performance, last day ends 1.5 hours after last performance
        // default start/end times are 1.5 hours before first performance and 1 hour after last performance
        var startTime = index == 0 ? moment(daySlots[0].time_start).subtract(2,'hours') : moment(daySlots[0].time_start).subtract(1.5,'hours')
        var endTime = index == slotsArray.length-1 ? moment(daySlots[daySlots.length-1].time_start).add(1.5,'hours') : moment(daySlots[daySlots.length-1].time_start).add(1,'hours')

        vm.required_dates.push({
          date: day,
          start_time: startTime,
          end_time: endTime
        })
      })
      vm.loading_table = false
    })
  }
}
</script>